import { useEffect, useState } from "react";
import { Alert, AlertMessage, AlertTitle } from "./Style";
import { style } from "./StyleType";
import TmpIconCustom from "../TmpIconCustom/TmpIconCustom";
import { ReactComponent as IconSucesso } from "../../../assets/icons/sucesso.svg";
import { ReactComponent as IconError } from "../../../assets/icons/erro.svg";
import TmpTypographyCustom from "../TmpTypographyCustom/TmpTypographyCustom";

interface TmpAlertCustomProps {
    isOpened: boolean;
    title: string;
    message: string;
    type: "error" | "success";
    onClick?: () => void;
}

export default function TmpAlertCustom(props: TmpAlertCustomProps) {
    const [_isOpened, setOpen] = useState<boolean>(props.isOpened);

    useEffect(() => {
        setOpen(props.isOpened);
    }, [props.isOpened]);

    // Events
    
    // Passing style props to styled component
    Alert.defaultProps = style;
    AlertTitle.defaultProps = style;
    AlertMessage.defaultProps = style;

    return (
        <Alert type={props.type} isOpened={_isOpened} data-testid="alert" role="alert">
            <AlertTitle>
                {props.type === "error" ? (
                    <TmpIconCustom icon={<IconError />} size="md" />
                ) : (
                    <TmpIconCustom icon={<IconSucesso />} size="md" />
                )}

                <TmpTypographyCustom component="heading" variant="h3" size="small" id="texto-titulo">
                    {props.title}
                </TmpTypographyCustom>
               
            </AlertTitle>

            <AlertMessage>
                <TmpTypographyCustom component="paragraph" size="small" id="texto-alerta" variant="h5">
                    {props.message}
                </TmpTypographyCustom>
            </AlertMessage>
        </Alert>
    );

}